import React from "react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../@/components/ui/dateRangeSelect";

interface SelectorProps {
  selectedRange: "thisWeek" | "lastWeek" | "thisMonth" | "lastMonth";
  onRangeChange: (
    range: "thisWeek" | "lastWeek" | "thisMonth" | "lastMonth"
  ) => void;
}

const Selector: React.FC<SelectorProps> = ({
  selectedRange,
  onRangeChange,
}) => {
  const handleSelectChange = (value: string) => {
    onRangeChange(value as "thisWeek" | "lastWeek" | "thisMonth" | "lastMonth");
  };

  return (
    <Select onValueChange={handleSelectChange} value={selectedRange}>
      <SelectTrigger className="w-28 h-2 border-none  select-none text-[1.7vh] outline-none font-helvetica text-customGrayLight ring-0 focus:ring-0 focus:border-0">
        <SelectValue placeholder="Select Range" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="thisWeek">This Week</SelectItem>
        <SelectItem value="lastWeek">Last Week</SelectItem>
        <SelectItem value="thisMonth">This Month</SelectItem>
        <SelectItem value="lastMonth">Last Month</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default Selector;
